import React from 'react';
import {
  IconBan,
  IconClock,
  IconAlertTriangle,
  IconLogout
} from '@tabler/icons-react';

const BannedModal = ({ banInfo, onLogout }) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return 'Навсегда';
    const date = new Date(dateStr);
    return date.toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const isPermanent = !banInfo.until;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-dark-950/90 backdrop-blur-sm">
      {/* Modal */}
      <div className="relative w-full max-w-md">
        <div className="relative bg-dark-900 border border-dark-800 rounded-2xl shadow-xl overflow-hidden">
          {/* Header with icon */}
          <div className="relative pt-8 pb-4 px-6 text-center">
            {/* IconBan icon */}
            <div className="mx-auto w-16 h-16 mb-4 bg-primary-500/10 rounded-2xl flex items-center justify-center">
              <IconBan className="w-8 h-8 text-primary-500" />
            </div>

            <h1 className="text-2xl font-bold text-white mb-1">
              Аккаунт заблокирован
            </h1>
            <p className="text-dark-400 text-sm">
              @{banInfo.username}
            </p>
          </div>

          {/* Content */}
          <div className="px-6 pb-6 space-y-3">
            {/* Reason card */}
            <div className="bg-dark-800/50 border border-dark-700 rounded-xl p-4">
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 bg-primary-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <IconAlertTriangle className="w-4 h-4 text-primary-500" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-xs font-medium text-dark-400 mb-0.5">Причина</h3>
                  <p className="text-white text-sm">
                    {banInfo.reason || 'Нарушение правил сервиса'}
                  </p>
                </div>
              </div>
            </div>

            {/* Duration card */}
            <div className="bg-dark-800/50 border border-dark-700 rounded-xl p-4">
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 bg-dark-700 rounded-lg flex items-center justify-center flex-shrink-0">
                  <IconClock className="w-4 h-4 text-dark-400" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-xs font-medium text-dark-400 mb-0.5">Срок блокировки</h3>
                  <p className={`text-sm font-medium ${isPermanent ? 'text-primary-500' : 'text-white'}`}>
                    {isPermanent ? 'Перманентная' : `До: ${formatDate(banInfo.until)}`}
                  </p>
                </div>
              </div>
            </div>

            {/* Info text */}
            <p className="text-center text-dark-500 text-xs py-2">
              Если вы считаете, что произошла ошибка, обратитесь в{' '}
              <a
                href="https://t.me/XNCsup_bot"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-500 hover:text-primary-400 underline"
              >
                Telegram поддержку
              </a>
            </p>

            {/* Action button */}
            <button
              onClick={onLogout}
              className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-dark-800 hover:bg-dark-700 border border-dark-700 hover:border-dark-600 rounded-xl text-white text-sm font-medium transition-all"
            >
              <IconLogout className="w-4 h-4" />
              <span>Выйти из аккаунта</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannedModal;
